"use client"

import { useEffect, useState } from "react"
import { Button } from "@/components/ui-lab/button"
import { BiUpArrowAlt } from "react-icons/bi"

export const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300)
    }

    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  if (!isVisible) return null

  return (
    <Button variant="outline" size="icon-lg" onClick={handleScrollToTop} aria-label="Scroll to top">
      <BiUpArrowAlt size={22} />
    </Button>
  )
}
